/* istanbul ignore file */
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpBaseService } from '../../../core';
import { environment } from '../../../environments/environment';
import { Dashboard } from '../../models';
import { DashboardAccessStatus } from '../../shared/enums';

@Injectable({
    providedIn: 'root'
})
export class DashboardsDataService extends HttpBaseService {
    private route = environment.api + 'apps/';

    constructor(
        private _httpClient: HttpClient,
    ) {
        super(_httpClient);
    }

    createDashboard(appId: string, projectId: string, dashboardToCreate: Dashboard): Observable<Dashboard> {
        const url = `${this.route}${appId}/projects/${projectId}/dashboards`;
        return this.httpPost(url, dashboardToCreate);
    }

    getDashboardsByProject(appId: string, projectId: string): Observable<Dashboard[]> {
        const url = `${this.route}${appId}/projects/${projectId}/dashboards`;
        return this.httpGet(url);
    }

    getDashboardsByProjectByPermissions(appId: string, projectId: string, userId: string): Observable<Dashboard[]> {
        const url = `${this.route}${appId}/projects/${projectId}/dashboards/by-permissions/${userId}`;
        return this.httpGet(url);
    }

    getDashboardAccessStatus(appId: string, projectId: string, dashboardId: string): Observable<DashboardAccessStatus> {
        const url = `${this.route}${appId}/projects/${projectId}/dashboards/${dashboardId}/access`;
        return this.httpGet(url);
    }

    getSummaryDashboardsByPermissions(appId: string, summaryProjectId: string): Observable<Dashboard[]> {
        const url = `${this.route}${appId}/summary-projects/${summaryProjectId}/dashboards/by-permissions`;
        return this.httpGet(url);
    }

    getSummaryDashboardAccessStatus(appId: string, summaryProjectId: string, dashboardId: string): Observable<DashboardAccessStatus> {
        const url = `${this.route}${appId}/summary-projects/${summaryProjectId}/dashboards/${dashboardId}/access`;
        return this.httpGet(url);
    }

    updateDashboard(appId: string, projectId: string, dashboardToUpdate: Dashboard): Observable<Dashboard> {
        const url = `${this.route}${appId}/projects/${projectId}/dashboards/${dashboardToUpdate.id}`;
        return this.httpPut(url, dashboardToUpdate);
    }

    updateDashboardActiveStatus(appId: string, projectId: string, dashboard: Dashboard, newActiveStatus: boolean): Observable<Dashboard> {
        const url = `${this.route}${appId}/projects/${projectId}/dashboards/${dashboard.id}/active`;
        return this.httpPut(url, newActiveStatus);
    }

    deleteDashboard(appId: string, projectId: string, dashboardId: string): Observable<boolean> {
        const url = `${this.route}${appId}/projects/${projectId}/dashboards/${dashboardId}`;
        return this.httpDelete(url);
    }
}
